import { render, staticRenderFns } from "./PricelistPricePeriod.vue?vue&type=template&id=634c6a47"
import script from "./PricelistPricePeriod.vue?vue&type=script&lang=js"
export * from "./PricelistPricePeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports